import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, updateDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

const relationshipsCollection = collection(db, "relationships");

const relationshipService = { 
  getAll: async () => {
    try {  
      const relationshipsSnapshot = await getDocs(relationshipsCollection);
      const relationshipsList = relationshipsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      return relationshipsList;
    } catch (error) {
      console.error('Error fetching relationships:', error);
      throw error;
    }
  },
  add: async (relationshipsData) => {
    try {
      const docRef = await addDoc(relationshipsCollection, relationshipsData);
      return docRef;
    } catch (error) {
      console.error('Error adding relationship:', error);
      throw error;
    }
  },
  edit: async ({ id, data }) => {
    try {
      const relationshipRef = doc(db, 'relationships', id);
      await updateDoc(relationshipRef, data);
    } catch (error) {
      console.error('Error updating relationship:', error);
      throw error;
    }
  },
  delete: async (relationshipId) => {
    try {
     await deleteDoc(doc(db, "relationships", relationshipId));
     return true;
    } catch (error) {
      console.error('Error deleting relationship:', error);
      throw error;
    }
  },
  getNameById: async (relationshipId) => {
    try {
     const relationshipRef = doc(db, 'relationships', relationshipId);
     const relationshipSnap = await getDoc(relationshipRef);

     if (relationshipSnap.exists()) {
       return relationshipSnap.data().name;  
     }
     else {
       return null; 
     }
    } 
    catch (error) {
      console.error('Error getting relationship name:', error);
      throw error; 
    }
  },

  getIdByName: async (relationshipName) => {
    try {
      const relationshipsSnapshot = await getDocs(relationshipsCollection);
      const relationshipsList = relationshipsSnapshot.docs.map(doc => ({
        id: doc.id,
       ...doc.data()
      })); 

      const formattedRelationshipName = relationshipName.trim().toLowerCase().replace(/\s+/g, '');

      const relationship = relationshipsList.find(relationship => relationship.name.toLowerCase().replace(/\s+/g, '')  === formattedRelationshipName);
      return relationship ? relationship.id : null;
    }
    catch (error) {
      console.error('Error getting relationship id:', error);
      throw error; 
    } 
  },
};

export default relationshipService;